(function () {
  function delay() {
    setTimeout(function () {
      document.getElementById("smile-ui-container").style.zIndex = "999";
    }, 2000);
  }

  if (document.readyState == "complete") {
    delay();
  } else {
    document.onreadystatechange = function () {
      if (document.readyState === "complete") {
        delay();
      }
    };
  }
})();
